export default {
  ecosystem: {
    subtitle: "WHY MAHAL",

    title1: "Be a Part of the",
    title2: "MAHAL Ecosystem",

    desc:
      "MAHAL is more than a marketplace, it’s an ecosystem connecting restaurants, suppliers, and professionals to grow together.",

    text:
      "Be a part of a growing network of restaurants and suppliers who are transforming procurement with transparency, efficiency, and long-term partnerships, powered by one unified digital platform.",

    cta: "Join 500+ Businesses",
  },
};